<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   width="2000"
   height="1456"
   viewBox="0 0 529.16665 385.23334"
   version="1.1"
   id="svg110"
   inkscape:version="1.1.2 (0a00cf5339, 2022-02-04)"
   sodipodi:docname="bottom.svg"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview112"
     pagecolor="#ffffff"
     bordercolor="#000000"
     borderopacity="0.25"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:document-units="mm"
     showgrid="false"
     units="px"
     inkscape:zoom="0.20873304"
     inkscape:cx="893.48576"
     inkscape:cy="390.45088"
     inkscape:window-width="1920"
     inkscape:window-height="1137"
     inkscape:window-x="1920"
     inkscape:window-y="1200"
     inkscape:window-maximized="1"
     inkscape:current-layer="layer8"
     showguides="false" />
  <defs
     id="defs107">
    <style
       type="text/css"
       id="style2">.dataURL { &quot;);            font-display:auto;font-style:normal;font-weight:400;font-stretch:normal; }
</style>
  </defs>
  <g
     inkscape:groupmode="layer"
     id="layer7"
     inkscape:label="Bottom Text Path"
     style="display:none">
    <path
       style="fill:#ffffff;stroke-width:0.264583;-inkscape-stroke:none;stop-color:#000000"
       d="M 0.21077915,328.98659 C 170.49124,396.03122 348.01856,397.62638 530.03297,328.46413"
       id="path33719"
       sodipodi:nodetypes="cc" />
  </g>
  <g
     inkscape:groupmode="layer"
     id="layer8"
     inkscape:label="Bottom Text"
     style="display:inline">
    <text
       xml:space="preserve"
       style="font-size:28.2222px;line-height:normal;font-family:my-custom-font;text-align:center;text-decoration-color:#000000;text-anchor:middle;display:inline;fill:#000000;stroke-width:0.264583;-inkscape-stroke:none;stop-color:#000000"
       id="text2971-6"
       transform="translate(0,-7.9374992)"><textPath
         xlink:href="#path33719"
         startOffset="50%"
         id="textPath34276"
         style="font-weight:bold"></textPath></text>
  </g>
</svg>
